// Copyright (c) 2017 Deere & Company

import * as actions from '../../actions-list';
import AuditRecording from '@deere/cps-it.warranty-model-factory/lib/audit-recording';
import {getDefaultState} from '../state';

const updateRecordAuditsData = (state, action) =>
    AuditRecording.update(state, {
        $merge: action.audit
    });

const updateAuditResults = (state, action) =>
    AuditRecording.update(state, {
        auditResults: {$set: action.results}
    });

const updateRecordAuditFile = (state, action) =>
    AuditRecording.update(state, {
        file: {$set: action.file}
    });

const updateActualAuditDate = (state, action) =>
    AuditRecording.update(state, {
        actualAuditDate: {$set: action.auditDate}
    });

export default (state = getDefaultState().auditRecording, action) => {

    const actionTypes = {
        [actions.UPDATE_TCSM_RECORD_AUDIT_ACTUAL_AUDIT_DATE]: updateActualAuditDate,
        [actions.UPDATE_TCSM_RECORD_AUDIT_DATA]: updateRecordAuditsData,
        [actions.UPDATE_TCSM_RECORD_AUDIT_FILE]: updateRecordAuditFile,
        [actions.UPDATE_TCSM_RECORD_AUDIT_RESULTS]: updateAuditResults
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/tcsm/record-audit/reducers/audit-recording.js